<div class="mb-promo">
    <HeaderComponent
            :path-image-bck="'2022'"
    />
    <main>
        <section>
            <div class="wide-content-wrapper-cnt">
                <div class="chart-wrapper-intro">
                    <h2 v-html="t('landing.title.2022.chart')"></h2>
                    <p v-html="t('landing.text.2022.chart')"></p>
                </div>
                <div class="chart-wrapper">
                    <ImageBoxComponent
                            v-for="image in chartPreviousYear"
                            :key="image.id"
                            :image-path="image.imgPath"
                            :selected="image.selected"
                            :ranking="image.ranking"
                            type="chart"
                    ></ImageBoxComponent>

                    <ModalComponent></ModalComponent>
                </div>

                <div class="go-to-chart">
                    <ButtonComponent
                            :text="t('home.cta.chart')"
                            href="/lacartadelmulino/fiori-del-mulino/2022/classifica"
                    ></ButtonComponent>
                </div>
            </div>
        </section>

        <section>
            <SectionBanner
                    :title="'The Exhi<b>bee</b>tion,<br>I Fiori<br>Del Mulino'"
                    :description="'Guardare la biodiversità da un punto di vista diverso <br><b>è il primo passo per difenderla</b>.'"></SectionBanner>
        </section>

        <section>
            <SectionPlainText
                :description="'<b>Mulino Bianco nel 2022 lancia la prima mostra<br>sulla sostenibilità</b><br><br><b>The Exhibeetion</b> è un esperienza immersiva<br>che ti permette di <b>vedere i fiori dagli occhi di un ape</b>.' +
                 '<br><br> Vola con lei in un <b>viaggio</b> tra i campi di fiori nati grazie alla Carta del Mulino<br> per <b>difendere</b> la <b>biodiversità</b> e gli <b>insetti impollinatori</b>.'"></SectionPlainText>

            <Video :id="'0qcPsno-7Ck'"
                   :title="'The Exhibeetion - i Fiori del Mulino | esperienza immersiva a 360°'"></Video>
        </section>

        <section class="two-columns-container">
            <div class="wide-content-wrapper-cnt">
                <TwoColumns
                        :title="'Il punto di vista<br><b>di Simone Bramante</b>'"
                        :image-path="require('../../assets/sections/pov-brahmino.png')"
                        :description="'Simone Bramante, in arte Brahmino, è un <b>fotografo</b> cresciuto in provincia di Modena, <b>nei campi della pianura</b>.<br><br>Con questo progetto fotografico, che prosegue il suo <b>stile surrealista</b> e la sua <b>narrativa onirica</b>, l’artista è tornato da un lato alle sue <b>origini emiliane</b>, dall’altro alla <b>natura dei campi in cui è cresciuto</b>. '"
                        :flip="true" />

                <TwoColumns
                        :title="'Il punto di vista<br><b>degli agricoltori</b>'"
                        :image-path="require('../../assets/sections/pov-agricoltori.png')"
                        :description="'<b>I Fiori del Mulino</b> è il concorso che premia <b>l’azienda agricola</b> che si è distinta nel destinare ai fiori il <b>3% dei campi di grano tenero</b>, seguendo La Carta del Mulino. I coltivatori, invitati a scattare una <b>foto</b> della propria <b>distesa fiorita</b>, hanno risposto in gran numero, cercando di cogliere ogni sfumatura della <b>bellezza</b> che la loro scelta etica e il loro lavoro hanno regalato alla <b>biodiversità</b>.'" />

                <TwoColumns
                        :title="'Il punto di vista<br><b>delle api</b>'"
                        :image-path="require('../../assets/sections/pov-api.png')"
                        :description="'Ogni ape ha <b>5 occhi</b> e vede il mondo attraverso <b>4 cromie</b>, con le loro sfumature: giallo (arancio, verde giallastro), verde bluastro, blu e la gamma dei colori ultravioletti, da noi non percepibile. Questo permette loro di <b>vedere i fiori</b> e il <b>polline</b> in modo <b>unico e spettacolare</b>. Anche grazie a ciò, dalle api dipende circa il <b>90% delle piante selvatiche con fiore e l’80% delle piante produttrici di cibo</b> e prodotti per l\'uomo.<br><br><b>The Exhibeetion</b> unisce il punto di vista delle <b>api</b> e quello delle <b>persone</b>, perché guardare la <b>biodiversità</b> da una prospettiva diversa è il primo passo per <b>difenderla</b>.'"
                        :flip="true" />

                <TwoColumns
                        :title="'Il nuovo logo'"
                        :image-path="require('../../assets/sections/mb-nuovo-logo.png')"
                        :description="'Un nuovo logo per raccontare <b>l\'equilibrio tra natura e saper fare</b>. Al centro il <b>Mulino</b> e da cornice le <b>spighe di grano e i fiori</b>, elementi che rappresentano il rapporto tra <b>uomo e natura</b>, fatto di generosità, cura e rispetto. Il festone ci ricorda che il cibo ben fatto porta <b>gioia</b> a tavola e si aggiunge infine un piccolo e vitale soggetto: <b>l’ape</b>, preziosa impollinatrice, che vola in <b>un mondo ricco di biodiversità</b>.'" />
            </div>
        </section>

        <div class="wide-content-wrapper-cnt">
            <div class="general-rules tac"><div v-html="t('general.rules')"></div></div>
        </div>

    </main>
    <FooterComponent type="homepage"></FooterComponent>
</div>